import {AfterViewInit, Component, inject, QueryList, ViewChildren} from '@angular/core';
import { GestionarActividadesPendientesComponent } from './gestionar-actividades-pendientes/gestionar-actividades-pendientes.component';
import { TabViewModule } from 'primeng/tabview';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-gestion-pqrsd',
  standalone: true,
  imports: [TabViewModule, TranslateModule, CustomTitle,
    GestionarActividadesPendientesComponent],
  templateUrl: './gestion-pqrsd.component.html',
  styleUrl: './gestion-pqrsd.component.scss'
})
export class GestionPQRSDComponent implements AfterViewInit {
  activeTabIndex: number = 0;

  @ViewChildren(GestionarActividadesPendientesComponent) pendientes !: QueryList<GestionarActividadesPendientesComponent>;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor() { }

  ngAfterViewInit(): void {
    this.titleService.changeTitle('msg.gestionPQRSD');
    this.pendientes.get(0)?.getAllMisPqrsd();
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if (this.pendientes && this.pendientes.length > index) {
      this.pendientes.get(index)?.getAllMisPqrsd();
    }
  }
}
